import {
  CREATE_BARCODES_REQUESTED,
  CREATE_BARCODES_SUCCESS,
  CREATE_BARCODES_FAILURE,
  CREATE_ALL_BARCODE_IMAGES_REQUESTED,
  CREATE_ALL_BARCODE_IMAGES_SUCCESS,
  CREATE_ALL_BARCODE_IMAGES_FAILURE,
  CREATE_ALL_BARCODE_VALUES_REQUESTED,
  CREATE_ALL_BARCODE_VALUES_SUCCESS,
  CREATE_ALL_BARCODE_VALUES_FAILURE,
  REFRESH_BATCHES_REQUESTED,
  REFRESH_BATCHES_SUCCESS,
  REFRESH_BATCHES_FAILURE,
  DOWNLOAD_BARCODE_IMAGE_REQUESTED,
  DOWNLOAD_BARCODE_IMAGE_SUCCESS,
  DOWNLOAD_BARCODE_IMAGE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  status: 'waiting',
  generateActions: [],
  downloadUrl: '',
  errors: null
};

const barcodes = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case CREATE_BARCODES_REQUESTED:
    case CREATE_ALL_BARCODE_IMAGES_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        downloadUrl: null,
        status: 'requesting'
      });

    case CREATE_BARCODES_SUCCESS:
    case CREATE_ALL_BARCODE_IMAGES_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        generateActions: [...state.generateActions, action.payload.action],
        downloadUrl: null,
        errors: null
      });

    case CREATE_BARCODES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        downloadUrl: null,
        errors: 'error here'
      });

    case CREATE_ALL_BARCODE_IMAGES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        downloadUrl: null,
        errors: 'error here'
      });

    case REFRESH_BATCHES_SUCCESS:
      return Object.assign({}, state, {
        downloadUrl: null,
        generateActions: action.payload.generate_actions
      });

    case DOWNLOAD_BARCODE_IMAGE_SUCCESS:
      return Object.assign({}, state, {
        downloadUrl: action.payload.image_url
      });

    default:
      return state;
  }
}

export default barcodes;
